import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from '@mui/material';

export default function EllipsisTooltip({ children }) {
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip
      title={isOverflow ? children : ''}
      arrow
      disableHoverListener={!isOverflow}
    >
      <span
        ref={textRef}
        style={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}